<script>
    import { project_list, show_sidebar, active_breadcrumb } from '../../../app-store';
    import { navigate } from "svelte-routing";
    import { onMount } from "svelte";
    import { fly, fade } from 'svelte/transition';
    import CompetitorVennDiagram from "./competitor-venn-diagram.svelte";
    import ProjectSettings from "../../dashboard/project-settings.svelte";

    export let params;

    let project;

    $: project = $project_list.find((p) => p.project_ref === params.project_ref);

    let isCreatingDraft = false;
    let venn_competitor_keywords_count = [];
    let isLoadingCompetitorKeywordsCount = false;
    let competitor_keywords_count_error_msg = "";

    active_breadcrumb.set("breadcrumb-project"); // TODO: set this as project title

    const createNewDraft = async () => {
        app.body_spinner.add_to(document.body);
        app.body_spinner.set_message("Creating new draft...");
        isCreatingDraft = true;
        try {
            const { status, refcode: createdRefCode, msg } = await app.lucep_ai.create_draft(params.project_ref);
            if (status === "ok") {
                navigate(`/new-draft/${params.project_ref}/${createdRefCode}`);
            } else {
                console.error("Error creating new draft:", error);
                app.toast_msg.show("Error creating new draft: " + (msg || "Unknown error"));
            }
        } catch (error) {
            console.error("Error creating new draft:", error);
            app.toast_msg.show("Error creating new draft: " + (error.msg || "Unknown error"));
        } finally {
            app.body_spinner.remove();
            isCreatingDraft = false;
        }
    };

    onMount(() => {
        show_sidebar.set(true);
        isLoadingCompetitorKeywordsCount = true;
        app.lucep_ai
            .get_competitor_keywords_count(params.project_ref)
            .then(({ competitor_keywords_count }) => {
                // Convert the "set" key to "sets" as required by the venn diagram
                venn_competitor_keywords_count = competitor_keywords_count.map((item) => {
                    return {
                        sets: item.set,
                        size: item.size,
                    };
                });
            })
            .catch((e) => {
                competitor_keywords_count_error_msg = e.msg;
            }).finally(() => {
                app.body_spinner.remove();
                isLoadingCompetitorKeywordsCount = false;
            });
    });

    let showSettings = false;
    const handleConfigClick = () => showSettings = true;
    const closeSettings = () => showSettings = false;

</script>

<div class="app-screen new-draft new-draft-screen">
    <div id="dashboard" class="action-area">
        <h1 class="project_title">Project - {project.name}
            <button class="btn btn-light btn-project-setting" on:click={handleConfigClick}>
                <img src="/img/settings-5-line.svg" width="30" height="30" alt="Project Settings" />
            </button>
        </h1>
        {#if venn_competitor_keywords_count.length}
            <CompetitorVennDiagram competitor_keywords_count={venn_competitor_keywords_count} />
        {:else}
            {#if isLoadingCompetitorKeywordsCount}
                <p class="text-center">Loading competitor keywords...</p>
            {:else}
                <p class="text-center">{competitor_keywords_count_error_msg}</p>
                <p class="text-center">
                    Keyword clusters haven't been processed yet for this project.<br>
                    If you'd like to get started, please reach out to the Lucep team<br>
                    Prepare a list of your competitors to request the keyword clustering.
                </p>
            {/if}
        {/if}
        <button
            disabled={isCreatingDraft}
            class="btn btn-primary justify-content-center p-3 display-3 mx-auto"
            on:click={createNewDraft}
        >
            Create New Draft
        </button>
    </div>
</div>
{#if showSettings}
    <div transition:fly="{{ x: 500, duration: 300 }}" class="offcanvas offcanvas-end show" tabindex="-1" style="width: 500px;">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasRightLabel">
                <span>Project Settings</span>
            </h5>
            <button type="button" class="btn-close" on:click={closeSettings}></button>
        </div>
        <div class="offcanvas-body">
            <ProjectSettings project={project} onSubmit={closeSettings} />
        </div>
    </div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div transition:fade="{{ duration: 200 }}" class="offcanvas-backdrop fade show" on:click={closeSettings}></div>
{/if}
<style>
    .project_title {
        font-size: 1.25rem;
    }
    .btn-project-setting {
        display: inline-block;
        border:none;
        border-radius: 20px;;
    }
</style>